import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ErrorHandler, NgModule } from '@angular/core';
import { AngularFireModule } from '@angular/fire';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ServiceWorkerModule } from '@angular/service-worker';
import { LoggerModule, NGXLogger } from 'ngx-logger';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LogRocketErrorHandler } from './logrocket-error-handler';
import { MaterialModule } from './material/material.module';
import { ApiIndicatorComponent } from './root/api-indicator/api-indicator.component';
import { AuthInterceptorService } from './root/auth-interceptor.service';
import { VersioningComponent } from './root/versioning/versioning.component';
import { SharedModule } from './shared/shared.module';
const firebaseConfig = {
  apiKey: 'AIzaSyC-c8kIxYnYOWHEnTBQiblF1bzFvyBAQZw',
  authDomain: 'lohi-f5606.firebaseapp.com',
  databaseURL: 'https://lohi-f5606.firebaseio.com',
  projectId: 'lohi-f5606',
  storageBucket: 'lohi-f5606.appspot.com',
  messagingSenderId: '471883051371',
  appId: '1:471883051371:web:dce9808351fc14c0f69c2e',
  measurementId: 'G-E35GJMJZN0',
};

@NgModule({
  declarations: [AppComponent, VersioningComponent, ApiIndicatorComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: !window.location.href.includes('localhost') }),
    AngularFireModule.initializeApp(firebaseConfig),
    AngularFireAuthModule,
    SharedModule,
    LoggerModule.forRoot({
      level: environment.logLevel,
      colorScheme: ['blue', 'teal', 'gray', 'gray', 'red', 'red', 'red'],
      enableSourceMaps: !environment.production,
    }),
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptorService,
      multi: true,
    },
    {
      provide: ErrorHandler,
      useClass: LogRocketErrorHandler,
      deps: [NGXLogger],
    },
  ],
  bootstrap: [AppComponent],
  exports: [],
})
export class AppModule {}
